import { Button } from "@mui/material";
import styled from "styled-components";

export const ButtonContainer = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 1.5rem;
  width: 100%;
`;

export const ConfirmButton = styled(Button)`
  && {
    background-color: #FE2F67;
    color: white;
    padding: 0.625rem 1.5rem;
    border-radius: 0.5rem;
    text-transform: none;
    font-size: 1rem;
    flex: 1;
    &:hover {
      background-color: #e62a5d;
    }
  }
`;

export const RejectButton = styled(Button)`
  && {
    background-color: #F3F4F6;
    color: #1F2937;
    padding: 0.625rem 1.5rem;
    border-radius: 0.5rem;
    text-transform: none;
    font-size: 1rem;
    flex: 1;
    &:hover {
      background-color: #E5E7EB;
    }
  }
`; 